import React from 'react'
import {FieldErrors, UseFormRegister, UseFormSetValue} from 'react-hook-form'
import {IApplicationFormData} from '../../models/application-form'
import {TextInput} from '../../../common/component/TextInput'
import WizardSectionCard from './sections/WizardSectionCard'

interface CompanyTrustStepProps {
  register: UseFormRegister<IApplicationFormData>
  errors?: FieldErrors<IApplicationFormData>
  setValue: UseFormSetValue<IApplicationFormData>
}

const CompanyTrustStep: React.FC<CompanyTrustStepProps> = ({register, errors}) => {
  return (
    <div>
      <WizardSectionCard title='Company / Trust Details' className='p-8'>
        <p className='text-muted mb-8 mt-2'>
          Capture core entity details. Upload handling remains a placeholder in this scaffold.
        </p>

        <TextInput
          name='companyTrustAbnAcn'
          label='ABN / ACN'
          placeholder='Entity identifier'
          register={register}
          errors={errors}
        />

        <TextInput
          name='companyTrustDirectorId'
          label='Director ID'
          placeholder='Director ID'
          register={register}
          errors={errors}
        />

        <div className='alert alert-secondary mt-5 mb-0'>
          You'll also need to upload a Letter of Authority.
        </div>
      </WizardSectionCard>
    </div>
  )
}

export default CompanyTrustStep
